import axios from "axios";
import * as mutationTypes from "../mutation-types";
import { NOMINATION_API_URL, NOMINEES_API_URL } from "../../constants/urls";

export class Nomination {
  constructor(data) {
    this.data = { ...data };
  }
  getId() {
    return this.data.id;
  }
  getName() {
    return this.data.name;
  }
  getDescription() {
    if (this.data.description) {
      return this.data.description
    }
    return '';
  }
  getLink() {
    return this.data.link;
  }
  getWinnerName() {
    return this.data.winnerName;
  }
  getItemIconStyle() {
    return this.data.iconImage !== ""
      ? { backgroundImage: `url(${this.data.iconImage})` }
      : null;
  }
  getType() {
    return this.data.type;
  }
}

const normalizeAwardPath = (path) => {
  if (typeof path !== "string" || path === "") {
    return "";
  }

  const normalizedPath = path
    .split(/[?#]/)[0]
    .replace(/^\/award(?=\/|$)/, "")
    .replace(/\/+$/, "");

  return normalizedPath === "" ? "/" : normalizedPath;
};

const findNominationByPath = (nominations, path) => {
  const normalizedPath = normalizeAwardPath(path);

  return nominations.find((nomination) => (
    normalizeAwardPath(nomination.link) === normalizedPath
  ));
};

const getInitialNomination = () => {
  if (typeof window === "undefined" || !window.CURRENT_RUBRIC) {
    return null;
  }

  const currentRubric = window.CURRENT_RUBRIC;
  const currentRegion = parseInt(window.CONTEXT_REGION, 10);
  const currentPath = normalizeAwardPath(window.location.pathname);
  const rubricLink = normalizeAwardPath(currentRubric.link);
  const isVotesRubricPage = /^\/votes\/[^/]+$/.test(currentPath);
  const isSameRegion = Number.isNaN(currentRegion)
    || typeof currentRubric.region === "undefined"
    || Number(currentRubric.region) === currentRegion;
  const isSamePath = rubricLink !== "" && currentPath === rubricLink;

  return isVotesRubricPage && isSameRegion && isSamePath
    ? currentRubric
    : null;
};

export default function () {
  const initialNomination = getInitialNomination();

  const state = {
    nomination: initialNomination,
    nominations: [],
    nominees: [],
    path: null,
    isNominationsLoading: false,
    nominationsLoadError: null,
  };

  const actions = {
    setCurrentPath({ commit }, path) {
      commit("path", path);
    },

    setNomination({ commit }, nomination) {
      commit(mutationTypes.SET_CURRENT_NOMINATION_SUCCESS, nomination);
    },

    loadNominees({ commit, dispatch, state }, params) {
      const host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });

      const url = `${host + NOMINATION_API_URL}${state.nomination.id}/`;

      axios
        .get(url, { withCredentials: true })
        .then((result) => {
          commit("loadNominees", result.data);

          dispatch("loader/decrement", {}, { root: true });
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          dispatch("loader/decrement", {}, { root: true });
        });
    },

    loadNominations({ commit, dispatch, state }, params) {
      const host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });
      commit("setNominationsLoading", true);
      commit("setNominationsLoadError", null);

      let currentYear = "";

      if (params && params.year) {
        currentYear = "?year=" + params.year;
      }

      const url = host + NOMINEES_API_URL + currentYear;

      axios
        .get(url, { withCredentials: true })
        .then(({ data: nominations }) => {
          commit(mutationTypes.FETCH_LIST_NOMINATIONS_SUCCESS, nominations);

          if (state.path !== null) {
            const currentNomination = findNominationByPath(nominations, state.path);

            commit(
              mutationTypes.SET_CURRENT_NOMINATION_SUCCESS,
              currentNomination || state.nomination
            );
          }

          dispatch("loader/decrement", {}, { root: true });
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          commit("setNominationsLoadError", "Не удалось загрузить список номинаций");
          dispatch("loader/decrement", {}, { root: true });
        })
        .finally(() => {
          commit("setNominationsLoading", false);
        });
    },

    setNominationByPath({ commit, state }, path) {
      const currentNomination = findNominationByPath(state.nominations, path);

      commit(mutationTypes.SET_CURRENT_NOMINATION_SUCCESS, currentNomination);
    },

    setYearByPath({ commit, state }, path) {
      const year = findNominationByPath(state.nominations, path);

      commit(mutationTypes.SET_CURRENT_NOMINATION_SUCCESS, year);
    },
  };

  const mutations = {
    [mutationTypes.SET_CURRENT_NOMINATION_SUCCESS](state, value) {
      state.nomination = value || null;
    },

    [mutationTypes.FETCH_LIST_NOMINATIONS_SUCCESS](state, value) {
      state.nominations = value;
    },

    path(state, value) {
      state.path = value;
    },

    setNominationsLoading(state, value) {
      state.isNominationsLoading = value;
    },

    setNominationsLoadError(state, value) {
      state.nominationsLoadError = value;
    },

    loadNominees(state, value) {
      state.nominees = value;
    },
  };

  const getters = {
    nomination({ nomination }) {
      return nomination;
    },

    nominations({ nominations = [] }) {
      return nominations.map((nomination) => new Nomination(nomination));
    },

    nominees({ nominees }) {
      return nominees;
    },

    isNominationsLoading({ isNominationsLoading }) {
      return isNominationsLoading;
    },

    nominationsLoadError({ nominationsLoadError }) {
      return nominationsLoadError;
    },
  };

  return {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
  };
}



// WEBPACK FOOTER //
// ./src/store/modules/nominations.js